
import React from 'react'
import Icon from './Icon'

const FaPieChart = props => (
    <Icon viewBox="0 0 40 40" {...props}>
        <g><path d="m17.6 19.9l12.2 12.2q-2.3 2.4-5.5 3.7t-6.7 1.3q-4.6 0-8.6-2.3t-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3v17z m4.2 0.1h17.3q0 3.5-1.4 6.7t-3.7 5.5z m15.8-2.9h-17.1v-17.1q4.7 0 8.6 2.3t6.2 6.2 2.3 8.6z"/></g>
    </Icon>
)

export default FaPieChart



// WEBPACK FOOTER //
// ./src/components/Icon/pie-chart.js